import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import axios from 'axios';
import { useState, useEffect } from 'react';
import FormulaComponent from './FormulaComponent';

const fetchFormulaInfo = async (credentials) => {
  const { data: response } = await axios(
      window.omataysPublicFormsPortlet.frontendProperties.apiUrl + '/public/getFormDetailsWithToken',
    {
      headers: {
        Authorization: `${credentials}`,
      },
    }
  );
  return response;
};

const AppContainerBase = (props) => {
  const location = useParams();
  const [formulaInfo, setFormulaInfo] = useState(null);

  useEffect(() => {
    if (location) {
      fetchFormulaInfo(location.credentials)
        .then((response) => {
          if(response.status === "ERROR") {
              console.error("error: ", response.errorCode);
          } else {
              setFormulaInfo(response.payload);
          }
        })
    }
  }, [location]);
  return (
    <>
      {formulaInfo && (
        <Suspense fallback={null}>
          <IntlProvider locale="fi-FI">
            <FormulaComponent
              formulaUrl={props?.formulaUrl}
              credentials={location.credentials}
              formId={formulaInfo.formId}
              formResponseId={formulaInfo.formResponseId}
            />
          </IntlProvider>
        </Suspense>
      )}
    </>
  );
};

export default AppContainerBase;
